/**
 * Wrapper über die axios AJAX-Library für saubere Fehlerbehandlung
 */

var _ = require('underscore');
var $ = require('jquery');
//var Promise = require('promise-polyfill');

/**
 * Erzeugt einen neuen AJAX-Request und gibt ein natives Promise zurück.
 * Zusätzlich werden bekannte Fehler-Probleme (500er, API Error) direkt abgefangen und
 * in saubere Fehler-Objekte umgewandelt.
 *
 * Folgende Argumente werden für den Request unterstützt:
 * - url: Ziel-URL (String)
 * - method: HTTP-Methode (Standard: GET)
 * - params: URL-Parameter (Objekt)
 * - data: HTML Body Data (Objekt)
 * - headers: Zusätzliche HTTP-Header (Objekt)
 * - responseType: text|json (Standard: json)
 *
 * Content-Type muss per headers = { "content-type": "application/json" } gesetzt werden.
 *
 * @param config {Object} Request-Argumente
 * @return {Promise} Gibt das Request-Ergebnis zurück
 */
var call = function(url, config) {
	/* This function can be called with 3 different signatures:
	   call("http://something")
	   call("http://something", {key: value})
	   call({url: "http://something", key: value})
	*/
	if ( typeof config === "undefined" ) {
		config = {};
	}
	if ( typeof url === "string" ) {
		config.url = url;
	}
	else if ( typeof url === "object" ) {
		config = url;
	}

	if ( !config.url ) {
		throw new Error("ajax.call: Needs url or config object as first parameter")
	}

	config = _.extendOwn({
		url: null,
		method: "get",
		params: {},
		data: {},
		headers: {},
		responseType: "json",
		timeout: null,
	}, config);

	_.extend(config.data, config.params);
	config.dataType = "json";

	/* Older versions of jQuery send null as "null" to the server, which is bad.
	   To be consistent with any backend, we manually delete null-values from the query */
	_.each(config.data, function(value, key) {
		if ( value === null ) {
			//console.log("[ajax] Removing null-key:", key);
			delete config.data[key];
		}
	});

	console.log("Doing an AJAX request to " + config.url);

	/* Error-Objekt erzeugen um Raven einen sauberen Stacktrace liefern zu können */
	var maybeError = new Error("AJAX call failed (unknown reason)");

	config.error = function(jqXHR, textStatus, errorThrown) {
		console.log("Ajax: Error catched: " + jqXHR.status + " (" + jqXHR.statusText + ")");
		maybeError.message = "AJAX call to " + config.url + " failed with code " + jqXHR.status + " (" + jqXHR.statusText + ")";
		if ( typeof window.Raven !== "undefined") {
				Raven.captureException(maybeError, {
				extra: {
					status: jqXHR.status,
					statusText: jqXHR.statusText,
					headers: jqXHR.getAllResponseHeaders(),
					url: config.url,
					method: config.method,
					data: config.data,
					params: config.params,
				},
			});
		};
		throw maybeError;
	};

	return Promise.resolve($.ajax(config.url, config));
}

module.exports = call;



// WEBPACK FOOTER //
// /Users/bm/app/code/jsapps/modules/ajax.js